{
  "version": 1,
  "asset_id": "1488337b-f8be-40dd-b700-2200b1058125",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/1488337b-f8be-40dd-b700-2200b1058125/white-metal-roof-crystal-river-fl-640.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/1488337b-f8be-40dd-b700-2200b1058125/white-metal-roof-crystal-river-fl-640.webp",
  "original_filename": "white-metal-roof-crystal-river-fl-640.webp",
  "size": 23788,
  "content_type": "image/webp",
  "created_at": "2026-07-16T15:36:48Z"
}
